/** Va à un bloc de la fiche. Le score est rendu deux fois (une colonne ou deux, selon la place) : on prend
 * l'exemplaire visible. Seul le conteneur qui défile bouge (le panneau, pas la liste à côté), avec une marge pour
 * que le bloc ne passe pas sous le bord. */
export const scrollToAnchor = (anchor: string) => {
  const target = [
    ...document.querySelectorAll<HTMLElement>(`[data-anchor="${anchor}"]`),
  ].find((element) => element.offsetParent !== null);
  if (!target) return;
  // Section repliée (les sources) : ouverte d'abord, puis saut direct une fois son contenu posé (un défilement
  // progressif est interrompu par le changement de hauteur).
  const fold = target.querySelector<HTMLDetailsElement>(
    "details[data-open-on-jump]",
  );
  if (fold && !fold.open) {
    // L'événement « toggle » arrive après coup ; le contenu est rendu juste après.
    fold.addEventListener(
      "toggle",
      () => setTimeout(() => scrollTo(target, "auto"), 50),
      {
        once: true,
      },
    );
    fold.open = true;
  } else scrollTo(target);
};

const scrollTo = (target: HTMLElement, behavior: ScrollBehavior = "smooth") => {
  let scroller = target.parentElement;
  while (
    scroller &&
    !(
      /(auto|scroll)/.test(getComputedStyle(scroller).overflowY) &&
      scroller.scrollHeight > scroller.clientHeight
    )
  )
    scroller = scroller.parentElement;
  const top = target.getBoundingClientRect().top - 16;
  if (scroller)
    scroller.scrollBy({
      top: top - scroller.getBoundingClientRect().top,
      behavior,
    });
  else window.scrollBy({ top, behavior });
};
